module.exports = __webpack_public_path__ + "assets/img/dad_daughter.0c5db1b0.jpg";